import React from "react";
import { Text } from "../../../subComponents/text";
import { Img } from "../../../subComponents/img";
import { MainHeading } from "../../../subComponents/MainHeading";
import { Divider } from "@mui/material";

export default function QualityPolicyObjective() {
  return (
    <section className="quality-policy-section">
      <div className="quality-policy-container shadow">
        <QualityPolicyCard
          title={<>Quality Policy</>}
          text={
            <>
              We are committed to satisfy our customer by providing quality
              products in time at competitive cost through continual
              improvements.
            </>
          }
          imgUrl={"/assets/images/AboutUs/quality-policy.png"}
        />
        <div className="devider-container">
          <Divider />
        </div>
        <QualityPolicyCard
          title={<>Quality Objective</>}
          text={
            <>
              ◉ &nbsp; Continual Improvement In process and quality.
              <br />
              ◉ &nbsp; Cost Control through rejection control & VA / VE.
              <br />
              ◉ &nbsp; Productivity level improvement.
              <br />
              ◉ &nbsp; Committed service to customers.
              <br />◉ &nbsp; Suppliers involvement for quality products.
            </>
          }
          imgUrl={"/assets/images/AboutUs/quality-objective.png"}
        />
      </div>
    </section>
  );
}

const QualityPolicyCard = ({ title, text, imgUrl }) => {
  return (
    <>
      <div className="quality-objective-container">
        {/* left container start from here */}
        <div className="left-quality-objective-container">
          <MainHeading title={title} />
          <Text text={text} />
        </div>
        {/* left container close from here */}

        {/* right container start from here */}
        <div className="right-quality-objective-container">
          <Img
            src={imgUrl}
            alt={"Quality policy"}
            style={{ maxWidth: "220px" }}
          />
        </div>
        {/* right container close from here */}
      </div>
    </>
  );
};
